export default "__VITE_ASSET__dbcc5ef6__"